import styled from 'styled-components/macro';

export const KitSelectorContainer = styled.div`
  width: 100%;
  min-height: 100%;
  display: grid;
  grid-template-columns: 42% 16% 42%;
`;
